import React,{useState, useEffect} from 'react'
import './AuditReport.css'
import reportIcon from '../../../assets/audit_assets/Audit_report/reportIcon.png';
import reportFileIcon from "../../../assets/audit_assets/Audit_report/reportFileIcon.png"; 
import { GoChevronDown , GoChevronRight} from "react-icons/go";
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getClients} from './../../../services/global_redux/globale_actions/Client.action';
import {getAuditReport,downloadAllSelectedReport,getlatestAudit,filteredAudit,auditReportFilterHeader} from './../../../services/audit_redux/audit_actions/Audit.action';
import selected_icon from '../../../assets/reUsableTemplates_assets/selected_icon.png';
import download_icon from '../../../assets/reUsableTemplates_assets/dowload_icon.png';
import MultiSelect from './../../reUsableTemplates/multiSelectDropdown/MultiSelect';

function getSessionUser() {
  try {
    return JSON.parse(sessionStorage.getItem("user") || "{}") || {};
  } catch {
    return {};
  }
}

function getAssignedClientUnits() {
  try {
    const mapped = JSON.parse(getSessionUser().client_and_unit || "[]");
    return Array.isArray(mapped) ? mapped : [];
  } catch {
    return [];
  }
}

function getAssignedUnits(clientId) {
  const entry = getAssignedClientUnits().find(
    (item) => String(item.client_id) === String(clientId)
  );
  return (entry?.unit_id || []).map(String);
}

function getLockedClientId() {
  const stored = sessionStorage.getItem("selectedClient");
  if (stored && stored !== "null") return stored;
  return getAssignedClientUnits()[0]?.client_id || "";
}

function formatPeriodLabel(value) {
  const raw = String(value || "").trim();
  const match = raw.match(/^(\d{4})-(\d{2})/);
  if (!match) return raw;
  const monthIndex = Number(match[2]) - 1;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  if (monthIndex < 0 || monthIndex > 11) return raw;
  return `${months[monthIndex]}-${match[1]}`;
}

function branchOptionLabel(unit) {
  const name = String(unit?.unit_name || "").trim();
  const city = String(unit?.Location_City || unit?.location_city || "").trim();
  const state = String(unit?.state || unit?.state_name || "").trim();
  const location = state && city ? `${state}, ${city}` : (state || city);
  const id = String(unit?.unit_id || "").trim();
  let place = "";
  if (name && location) place = `${name} (${location})`;
  else place = name || location || "";
  if (id && place) return `${id} - ${place}`;
  return id || place;
}

function AuditReport({showSnackbar ,setLoading}) {
  const sessionUser = getSessionUser();
  const isClient = sessionUser?.base_role === "Client";
  const [openSection, setOpenSection] = useState(null);
  const dispatch = useDispatch();
  const toggleSection = (name) => {
    setOpenSection(openSection === name ? null : name);
  };
  const navigate = useNavigate();
  const [minMonth, setMinMonth] = useState('');
  const [maxMonth, setMaxMonth] = useState('');
  const [fetchedData, setfetchedData] = useState([]);
  const [clientIDs, setClientIDs] = useState([]);
  const [selectedClient ,setSelectedClient]= useState('')
  const [selectedReport ,setSelectedReport]= useState('All Vendor Wise Report');  
  const [fromMonth, setFromMonth] = useState('');
  const [AuditId, setAuditId] = useState('');
  const [toMonth, setToMonth] = useState('');
  const [fetchedReport, setFetchedReport] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [auditIdOptions, setAuditIdOptions] = useState([]);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [form, setForm] = useState({
    selectedBranchOptions: [],
    selectedVendorOptions: [],
    selectedAuditIdOptions: []
  });


  
  const [showTooltip, setShowTooltip] = useState(false);
  const [checkedItemCount, setCheckedItemCount] = useState(0);
  const [fetcheAllReportData, setFetcheAllReportData] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  
  const [isAllChecked, setIsAllChecked] = useState(false);


  const selectedClientId = async (id)=>{
    if (isClient && id && String(id) !== String(getLockedClientId())) return;
    setSelectedClient(id);
    if (!id) {
      setMinMonth('');
      setMaxMonth('');
      setToMonth('');
      setFromMonth('');
      setVendorOptions([]);
      setBranchOptions([]);
      setAuditIdOptions([]);
      return;
    }
    const response = await dispatch(auditReportFilterHeader(id,'',''));
    if(response.success){
        setfetchedData(response.data);
      setMinMonth(response.data.data[0].start_period);
      setMaxMonth(response.data.data[0].end_period);
      
      setVendorOptions(response.data.data[0].vendors.map((item) => ({
        value: item.vendor_id,
        label: item.vendor_name,
      })));
      const assignedUnits = isClient ? getAssignedUnits(id) : [];
      setBranchOptions(response.data.data[0].units
        .filter((item) => !assignedUnits.length || assignedUnits.includes(String(item.unit_id)))
        .map((item) => ({
        value: item.unit_id,
        label: branchOptionLabel(item),
      })));
      setAuditIdOptions(response.data.data[0].audits.map((item) => ({
        value: item.audit_id,
        label: item.audit_name,
      })));
    }else{
      setMinMonth('');
      setMaxMonth('');
      setToMonth('');
      setFromMonth('');
    }
  }
  const fetchAllClient = async () => {
    try {
        const response = await dispatch(getClients());
        const rows = Array.isArray(response.data) ? response.data : [];
        setClientIDs(rows);
        if (!isClient) return;
        const lockedClient = getLockedClientId();
        const initialClient = lockedClient && rows.some((client) => String(client.client_id) === String(lockedClient))
          ? String(lockedClient)
          : "";
        if (initialClient) {
          sessionStorage.setItem("selectedClient", initialClient);
          await selectedClientId(initialClient);
        }
    } catch (err) {
        console.error("Failed to fetch clients:", err);
    }
  }
  useEffect(() => {
        fetchAllClient();
  }, [dispatch]);
  const handleClientChange = (id) => {
    if (isClient) return;
    selectedClientId(id);
  };
  const viewreports = (reportName = selectedReport)=>{
    if(selectedClient === ""){
          showSnackbar("Please enter required data", 'warning');
    }else if(fromMonth === "" || toMonth === ""){
          setFetchedReport([]);
          setFetcheAllReportData([]);
          showSnackbar("Please select from and to period", 'warning');
    }else if(reportName === "Branch & Vendor Wise Report" && form.selectedBranchOptions.length === 0){
          setFetchedReport([]);
          setFetcheAllReportData([]);
          showSnackbar("Please select the branch to view the audit report", 'warning');
    }else{
      
      const data =  {
        start_period: fromMonth,
        end_period: toMonth,
        client_id: selectedClient,
        audit_id:form.selectedAuditIdOptions,
        unit_id: reportName === "Branch & Vendor Wise Report" ? form.selectedBranchOptions : [],
        vendor_id: reportName === "Branch & Vendor Wise Report" ? form.selectedVendorOptions : [],
        report_name: reportName
      }
    getReport(data);
    }
  }
  
  const getReport = async (data)=>{
    const response = await dispatch(getAuditReport(data));
    if(response.success){
      setFetchedReport(response.data.data)
      setFetcheAllReportData(response.data.data)
    }else{
      setFetchedReport([])
      setFetcheAllReportData([])
      showSnackbar(response.message || "Could not load the report", "warning")
    }
  }
  const fromMonthChange = (id)=>{
    if(selectedClient === ""){
      showSnackbar("Please Select the Organisation", 'warning');
      setFromMonth('');
    }else{
      setFromMonth(id);

    }
    setToMonth('');
  }
  
  const toMonthChange = async(id)=>{
    setToMonth(id);

    
    try{
      const response = await dispatch(filteredAudit(selectedClient,fromMonth,id));
      if(response.success){
        console.log(response.data.data);
        
      }else{
      }
    }catch(err){
      // setLoading(false);
    }

  }
  
  const SelectReport =(id)=>{
    setSelectedReport(id);
    setFetchedReport([]);
    setFetcheAllReportData([]);
    setCheckedItems({});
    setIsAllChecked(false);
    setFromMonth('');
    setToMonth('');
    setForm({
      selectedBranchOptions: [],
      selectedVendorOptions: [],
      selectedAuditIdOptions: []
    });
  }


  
const selectedFilter = (id)=> {
  if(id === 'All'){
    setFetchedReport(fetcheAllReportData)
  }else{
    setFetchedReport(fetcheAllReportData.filter((item)=>item.audit_id === id))
  }
}

    
const handleCheckChange = (id) => {
  setCheckedItems(prevCheckedItems => ({
      ...prevCheckedItems,
      [id]: !prevCheckedItems[id]
  }));
};
const updateCheckAllState = () => {
  const allChecked = fetchedReport?.length > 0 && fetchedReport.every(item => checkedItems[item.id]);
  setIsAllChecked(allChecked);
};
useEffect(() => {
  updateCheckAllState();
  const count = Object.values(checkedItems).filter(Boolean).length;
  setCheckedItemCount(count);
}, [checkedItems]);
const headers = [
  // { key: "audit_id", value: "Audit ID"},
  { key: "audit_name", value: "Audit Name"},
  { key: "start_period", value: "Start Period"},
  { key: "end_period", value: "End Period"},
  { key: "vendor_name", value: "Vendor Name"},
  { key: "not_applicable", value: "Not Applicable"},
  { key: "not_complied", value: "Non Complaince"},
  { key: "complied", value: "Complaince"},
  { key: "score", value: "Score"}
];
const vendor_wise_headers = [
  { key: "actName", value: "Act Name"},
  { key: "complied", value: "Complaince"},
  { key: "not_applicable", value: "Not Applicable"},
  { key: "not_complied", value: "Non Complaince"},
  { key: "score", value: "Score"},
];
const handleCheckAll = (e) => {
  const checked = e.target.checked;
  setIsAllChecked(checked);

  const newCheckedItems = { ...checkedItems };
  fetchedReport.forEach((item) => {
    newCheckedItems[item.id] = checked;
  });

  setCheckedItems(newCheckedItems);
};


const handleDownloadSelected = () =>{  
  if (checkedItemCount == 0) {
    showSnackbar("select the row", 'warning');
  } else{
      const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[id]).map(id => (id));
      let data
      if(selectedReport === "All Vendor Wise Report"){
        data = {
          report_name:selectedReport,
          selectedIds: selectedIds,
          client_id: selectedClient,
          audit_id: form.selectedAuditIdOptions
        }
      }else if(selectedReport === "Branch & Vendor Wise Report"){
        data = {
          report_name:selectedReport,
          selectedIds: selectedIds,
          client_id: selectedClient,
          audit_id: form.selectedAuditIdOptions
        }
      }else if(selectedReport === "Act & Vendor Wise Report"){
        data = {
          report_name:selectedReport,
          selectedIds: selectedIds,
          client_id: selectedClient,
          audit_id: form.selectedAuditIdOptions,
          start_period: fromMonth,
          end_period: toMonth
        }
      }else if(selectedReport === "Vendor wise report"){
        data = {
          report_name:selectedReport,
          selectedIds: selectedIds,
          client_id: selectedClient,
          audit_id: form.selectedAuditIdOptions
        }
      }else{
        data = {
            report_name:selectedReport,
            selectedIds: selectedIds,
            client_id: selectedClient,
            audit_id: form.selectedAuditIdOptions
        }
      }
      submitdownload(data);
  }
}
const submitdownload = async (data) => {
  setLoading(false);
  try {
    let response
      response = await dispatch(downloadAllSelectedReport(data));
    
      if (response.success == true) {
          showSnackbar("Downloaded Successfully", 'success');
          setLoading(false);
          setCheckedItems({})
      } else {
          showSnackbar(response.message || response.error || "Download failed", 'warning');
          setLoading(false);
      }
  } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
  }
}
  return (
    <div className={`audit-report-contaier${selectedReport === "Branch & Vendor Wise Report" ? " audit-report-branch-open" : ""}`}>
      <h5 className='text-white title'>Report</h5>    
      <div className="audit-report-table-view pb-3">
        <div className="audit-report-table mb-3">
          <div className="report-section-container">
            <div className="row mt-2 ">
              <div className="col-md-12 table-report-view-card m-0 mt-2">    
                <div>

                  <div className="col d-flex justify-content-between m-2 pe-1 ">
                    <div className="table_main_img d-flex" >
                      <img src={reportIcon} alt="noImg" className='reportIcon' />
                      <p className='mt-2'>{selectedReport}</p>
                    </div>
                    <div className='float-end d-flex downandcheckicons'>   
                          <img src={download_icon} alt="noImg" className='download_icon p-0 m-0 me-2' onClick={handleDownloadSelected} />
                          <div className="formsTable_icon_btn" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                              <img src={selected_icon} alt="" />
                              {showTooltip && (
                                  <div className="tooltipww">
                                      Selected: {checkedItemCount}
                                  </div>
                              )}
                          </div>
                          <div className="dataTotalEntries"><p>Total Entries :{fetchedReport.length}</p></div>
                          {/* <div className="filter_or_createcomponentn">
                              <select name="" id=""  onChange={(e)=>selectedFilter(e.target.value)}>
                                  <option value="All">All</option>
                                  {
                                    fetcheAllReportData.map((item)=>(
                                      <option value={item.audit_id}>{item.audit_name}</option>
                                    ))
                                  }
                              </select>
                          </div> */}
                    </div>
                  </div>
                  
                  <div className="mb-2 row p-0 m-2">
                    <div className="form-group col-md-3">
                        <label>Organisation Name <span className='text-danger'>*</span></label>
                        <select
                          className={`form-select form-select-sm mb-2${isClient ? " audit-report-org-locked" : ""}`}
                          value={selectedClient}
                          onChange={(e) => handleClientChange(e.target.value)}
                          disabled={isClient}
                          aria-label="Organization"
                        >
                          <option value="">-- Select --</option>
                          {clientIDs?.map((client) => (
                              <option key={client.client_id} value={client.client_id}>
                                  {client.client_name}
                              </option>
                          ))}
                        </select>
                    </div>
                      <div className="form-group  col-md-3">
                        <label>Report Name <span className='text-danger'>*</span></label>
                        <select className="form-select form-select-sm mb-2" onChange={(e) =>SelectReport(e.target.value)}>
                          <option value="All Vendor Wise Report">All Vendor Wise Report data</option>
                          <option value="Branch & Vendor Wise Report">Branch & Vendor Wise Report</option>
                          <option value="Act & Vendor Wise Report">Act & Vendor Wise Report</option>
                          <option value="Vendor wise report">Vendor wise report</option>
                        </select>
                      </div>
                        <div className="form-group col-md-2">
                          <label>From Period <span className='text-danger'>*</span></label>
                          <input type="month" className="form-control form-control-sm w-100" min={minMonth} max={maxMonth} value={fromMonth} onChange={(e)=>fromMonthChange(e.target.value)} />
                        </div>
                        <div className="form-group col-md-2">
                          <label>To Period <span className='text-danger'>*</span></label>
                          <input type="month" className="form-control form-control-sm w-100" min={fromMonth} max={maxMonth} value={toMonth}  onChange={(e)=>toMonthChange(e.target.value)}  disabled={!fromMonth} />
                        </div>         
                      <div className="form-group col-md-2">
                        <label>Audit Name</label>
                        <MultiSelect
                          options={auditIdOptions}
                          value={form.selectedAuditIdOptions} 
                          onChange={(vals) => {
                            setForm({ ...form, selectedAuditIdOptions: vals });
                            // clearStepOneError();
                          }}
                          openDropdownId={openDropdownId}
                          setOpenDropdownId={setOpenDropdownId}
                          placeholder="Select Audit..."
                          id="auditId"
                        />
                      </div>
                      {selectedReport === "Branch & Vendor Wise Report" && 
                        <>
                          <div className="form-group col-md-2">
                            <label>Branch <span className='text-danger'>*</span></label>
                            {/* <select className="form-select form-select-sm mb-2">
                              <option value="">--select--</option>
                            </select> */}
                            <MultiSelect
                              className="audit-report-branch-select"
                              options={branchOptions}
                              value={form.selectedBranchOptions} 
                              onChange={(vals) => {
                                setForm({ ...form, selectedBranchOptions: vals });
                                // clearStepOneError();
                              }}
                              openDropdownId={openDropdownId}
                              setOpenDropdownId={setOpenDropdownId}
                              placeholder="Select branch..."
                              id='selected_branch_id'
                            />
                          </div>
                          <div className="form-group col-md-2">
                            <label>Vendor <span className='text-danger'>*</span></label>
                            {/* <select className="form-select form-select-sm mb-2">
                              <option value="">--select--</option>
                            </select> */}
                              <MultiSelect
                                options={vendorOptions}
                                value={form.selectedVendorOptions} 
                                onChange={(vals) => {
                                  setForm({ ...form, selectedVendorOptions: vals });
                                  // clearStepOneError();
                                }}
                                openDropdownId={openDropdownId}
                                setOpenDropdownId={setOpenDropdownId}
                                placeholder="Select vendor..."
                                id='selected_vendor_id'
                              />
                          </div>
                        </> 
                      }
                      {/* {selectedReport === "Act & Vendor Wise Report" && 
                        <div className="form-group col-md-2">
                          <label>Vendor <span className='text-danger'>*</span></label>
                            <MultiSelect
                              options={vendorOptions}
                              value={form.selectedVendorOptions} 
                              onChange={(vals) => {
                                setForm({ ...form, selectedVendorOptions: vals });
                              }}
                              openDropdownId={openDropdownId}
                              setOpenDropdownId={setOpenDropdownId}
                              placeholder="Select vendor..."
                              id='selected_vendor_id'
                            />
                        </div>
                      } */}
                           
                    <div className='col-md'>
                      <button className="btn btn-success mt-3 float-end mb-3" onClick={() => viewreports()}>
                        View
                      </button>
                    </div>
                    </div>
                    
                    <div className='audit-report-view-contaier'>
                      <div className="audit-report-view-table-view pb-3">        
                        
                        <div className="table-responsive reportTabel">
                          <table className="table table-bordered reportTable">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={isAllChecked}
                                    onChange={handleCheckAll}
                                  />
                                </th>
                                <th className="slno">SL No.</th>

                                {selectedReport === "Act & Vendor Wise Report" ? (
                                vendor_wise_headers.map((h) => (
                                  <th key={h.key}>{h.value}</th>
                                ))
                                ) : (
                                    headers.map((h) => (
                                      <th key={h.key}>{h.value}</th>
                                    ))
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {fetchedReport.length > 0 ? (
                                selectedReport === "Act & Vendor Wise Report" ? (
                                  fetchedReport.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          checked={checkedItems[item.id] || false}
                                          onChange={() => handleCheckChange(item.id)}
                                        />
                                      </td>

                                      <td>{index + 1}</td>

                                      {vendor_wise_headers.map((h) => (
                                        <td key={h.key}>
                                          {h.key === "start_period" || h.key === "end_period"
                                            ? formatPeriodLabel(item[h.key])
                                            : item[h.key]}
                                        </td>
                                      ))}
                                    </tr>
                                  ))

                                ) : (
                                  fetchedReport.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          checked={checkedItems[item.id] || false}
                                          onChange={() => handleCheckChange(item.id)}
                                        />
                                      </td>

                                      <td>{index + 1}</td>

                                      {headers.map((h) => (
                                        <td key={h.key}>
                                          {h.key === "start_period" || h.key === "end_period"
                                            ? formatPeriodLabel(item[h.key])
                                            : item[h.key]}
                                        </td>
                                      ))}
                                    </tr>
                                  ))

                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={
                                      selectedReport === "Act & Vendor Wise Report"
                                        ? headers.length + vendor_wise_headers.length + 2
                                        : headers.length + 2
                                    }
                                    className="text-center py-5"
                                  >
                                    No data available. Adjust filters to view reports.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div> 
                </div>  
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default AuditReport